// extracted by mini-css-extract-plugin
export default {"GiftingDetails":"GiftingDetails-styles__GiftingDetails__uIhXm"};